import React, { useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Popper } from "@material-ui/core";
import { bindPopper } from 'material-ui-popup-state/hooks';

const useStyles = (placement, zIndex) => makeStyles(theme => ({
    typography: {
        padding: theme.spacing(2)
    },
    popper: {
        zIndex: zIndex,
        marginBottom: placement.search('top') > -1 || placement === 'right-end' || placement === 'left-end' ? '1em' : 0,
        marginRight: placement.search('left') > -1 ? '1em' : 0,
        marginTop: placement.search('bottom') > -1 || placement === 'right-start' || placement === 'left-start' ? '1em' : 0,
        marginLeft: placement.search('right') > -1 ? '1em' : 0,
        borderRadius: '10px',
        boxShadow: '0 10px 35px 0 rgba(0, 0, 0, 0.1), 0 15px 10px 0 rgba(0, 0, 0, 0.02)',
        '&[x-placement*="bottom"] $arrow': {
            top: 0,
            left: 0,
            marginLeft: '8px',
            marginTop: '-0.9em',
            width: '3em',
            height: '1em',
            '&::before': {
                borderWidth: '0 1em 1em 1em',
                borderColor: `transparent transparent ${theme.palette.background.paper} transparent`,
            },
        },
        '&[x-placement*="top"] $arrow': {
            bottom: 0,
            left: 0,
            marginBottom: '-0.9em',
            width: '3em',
            height: '1em',
            '&::before': {
                borderWidth: '1em 1em 0 1em',
                borderColor: `${theme.palette.background.paper} transparent transparent transparent`,
            },
        },
        '&[x-placement*="right"] $arrow': {
            left: 0,
            marginLeft: '-0.9em',
            height: '3em',
            width: '1em',
            '&::before': {
                borderWidth: '1em 1em 1em 0',
                borderColor: `transparent ${theme.palette.background.paper} transparent transparent`,
            },
        },
        '&[x-placement*="left"] $arrow': {
            right: 0,
            marginRight: '-0.9em',
            height: '3em',
            width: '1em',
            '&::before': {
                borderWidth: '1em 0 1em 1em',
                borderColor: `transparent transparent transparent ${theme.palette.background.paper}`,
            },
        },
    },
    arrow: {
        position: 'absolute',
        fontSize: 15,
        marginTop: placement.search('left') > -1 || placement.search('right') > -1 ? '1em' : 0,
        width: '31.7px',
        height: '31.7px',
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: 0,
            height: 0,
            borderStyle: 'solid',
        },
    },

}));

export default function PositionedPopper({ children, popupState, placement, zIndex, ...props }) {
    const [arrowRef, setArrowRef] = React.useState(null);
    const classes = useStyles(placement, zIndex)();
    const wrapperRef = useRef(null);

    const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            popupState.close();
        }
    }

    const onClick = (event) => {
        event.stopPropagation();
        popupState.close()
    }

    const onContextMenu = (event) => {
        event.preventDefault();
        popupState.close();
    }

    useEffect(() => {
        if (popupState.popupId === 'tree-sub-level' || popupState.popupId === 'tree-level-1') {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    });

    return (
        <div>
            {
                popupState.isOpen && (popupState.popupId !== 'tree-sub-level' && popupState.popupId !== 'tree-level-1') && (
                    <div
                        onClick={onClick}
                        onContextMenu={onContextMenu}
                        style={{
                            zIndex: zIndex - 1,
                            position: 'fixed',
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0,
                            overflow: 'hidden'
                        }}
                    />
                )
            }
            <Popper
                ref={wrapperRef}
                className={classes.popper}
                {...bindPopper(popupState)}
                placement={placement}
                {...props}
                transition

                modifiers={{
                    arrow: {
                        enabled: true,
                        element: arrowRef
                    },
                    preventOverflow: {
                        enabled: true,
                        boundariesElement: 'viewport',
                    },


                }}
            >
                <span className={classes.arrow} ref={setArrowRef} />
                {children}
            </Popper>
        </div>
    );
}

